common.View.create('shop::website.modules.shopCheckout.order.Signed', {

    ajaxCalls: [],

    onDOMLoad() {
        this.initFieldChange();
    },

    initFieldChange()
    {
        this.element
            .find('input[name="signed"]')
                .change((event) => {
                    // Abort ajax calls
                    this.abortAjaxCalls();

                    // On delivery method change
                    this.initSignedFieldChange( $(event.currentTarget).val() );
                })
                .end();

    },

    async abortAjaxCalls()
    {
        // There are ajax calls running?
        if( this.ajaxCalls ) {
            // Abort all calls
            for(let i = 0; i < this.ajaxCalls.length; i++) {
                this.ajaxCalls[i].abort();
            }
        }
    },

    async initSignedFieldChange(value)
    {
        // Post
        let ajaxCallPromise = $.post(this.element.data('url') + '/set-signed', {
            signed: value
        });

        // Push to ajax calls
        this.ajaxCalls.push(ajaxCallPromise);

        // Wait for ajax call to finish
        await ajaxCallPromise;

        // Reload totals
        shop.website.modules.shopCheckout.order.Index.getInstance(this).reloadTotals();
    },

});
